import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { NbDialogRef, NbDialogService } from "@nebular/theme";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";
import { UserService } from "../../@core/services/user.service";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";

import { Product, ProductInventory } from "../../models/product.model";

import { ProductInventoryService } from "../../services/product-inventory.service";
import { ProductService } from "../../services/product.service";
import { DialogProductInventoryComponent } from "../dialog-product-inventory/dialog-product-inventory.component";
import { DialogViewPurchaseComponent } from "../dialog-view-purchase/dialog-view-purchase.component";
import { DialogViewReceiptComponent } from "../dialog-view-receipt/dialog-view-receipt.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { ShopService } from "../../services/shop.service";
import * as moment from "moment";
import { User } from "../../@core/data/users";
import { DialogProductInventoriesArchiveComponent } from "../dialogs/dialog-product-inventories-archive/dialog-product-inventories-archive.component";
import { Supplier } from "../../models/supplier.model";

@Component({
  selector: "ngx-dialog-product-inventories",
  templateUrl: "dialog-product-inventories.component.html",
  styleUrls: ["dialog-product-inventories.component.scss"],
})
export class DialogProductInventoriesComponent implements OnInit, OnDestroy {
  private alive = true;
  private destroy$: Subject<void> = new Subject<void>();
  @Input() header: string;
  @Input() shopId?: string;
  @Input() uid?: string;
  @Input() product?: Product;

  initInventory: ProductInventory;
  allInventories: ProductInventory[] = [];
  inventories: ProductInventory[] = [];
  receiveQuantity = 0;
  receiveAmount = 0;
  issueQuantity = 0;
  issueAmount = 0;
  balanceQuantity = 0;
  balanceAmount = 0;

  loading = false;
  submitted = false;

  @ViewChild("search") search: ElementRef;
  strSearch = "";

  periodType = "today";
  periodDate: Date = new Date();
  fromDate: Date = moment().startOf("day").toDate();
  toDate: Date = moment().endOf("day").toDate();
  selectedTime: any = null;
  user?: User;

  constructor(
    protected ref: NbDialogRef<DialogProductInventoriesComponent>,
    private userService: UserService,
    public shopService: ShopService,
    private inventoryService: ProductInventoryService,
    private productService: ProductService,
    private dialogService: NbDialogService,
  ) {}

  ngOnInit() {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          if (
            this.product.shopIdArchived != null &&
            this.product.shopIdArchived !== "" &&
            this.product.archivedId != null &&
            this.product.archivedId !== "" &&
            this.product.isInitInventory !== true
          ) {
            this.archiveData();
          } else {
            this.calculateProductStats(false);
          }
        } else {
          this.uid = "anonymous";
        }
      });

    console.log(
      "🚀 ~ DialogProductInventoriesComponent /ngOnInit ~ product:",
      this.product,
    );
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.alive = false;
  }

  cancel() {
    this.ref.close(this.product);
  }

  selectTime(value) {
    this.selectedTime = value;

    if (!value || value.type === "now") {
      this.fromDate = null;
      this.toDate = null;
    } else {
      this.periodDate = value.periodDate;
      this.fromDate = value.fromDate;
      this.toDate = value.toDate;
      this.periodType = value.period;
    }

    this.initInventory = null;
    this.getProductInventoriesByIssueDate();
  }

  async getProductInventoriesByIssueDate() {
    this.loading = true;

    const querySnapshot =
      await this.inventoryService.getProductInventoriesByIssueDate(
        this.shopId,
        this.product.id,
        this.fromDate,
        this.toDate,
        0,
      );

    let inventories = [];
    this.receiveQuantity = 0;
    this.receiveAmount = 0;
    this.issueQuantity = 0;
    this.issueAmount = 0;
    this.balanceQuantity = 0;
    this.balanceAmount = 0;

    querySnapshot.forEach((doc) => {
      let prod = new ProductInventory();
      prod = doc.data();
      prod.id = doc.id;
      prod.createdOn = convertTimestamp(prod.createdOn);
      prod.updatedOn = convertTimestamp(prod.updatedOn);
      prod.issueDate = convertTimestamp(prod.issueDate);

      inventories.push(prod);
    });

    this.calculateInventory(inventories);

    this.loading = false;
  }

  calculateInventory(data: ProductInventory[]) {
    let inventories: ProductInventory[] = data
      ? _.clone(data)
      : _.clone(this.inventories);
    _.sortBy(inventories, ["issueDate"]);

    this.inventories = [];
    this.receiveQuantity = 0;
    this.receiveAmount = 0;
    this.issueQuantity = 0;
    this.issueAmount = 0;
    this.balanceQuantity = 0;
    this.balanceAmount = 0;

    if (
      this.periodType === "thisYear" ||
      this.periodType === "recent" ||
      this.periodType === "thisMonth" ||
      this.periodType === "today"
    ) {
      _.remove(inventories, (o) => o.comment === "Đầu kỳ");

      if (!this.initInventory) {
        this.initInventory = new ProductInventory();

        const totalReceiveQuantity = _.sumBy(
          inventories,
          (o) => o.receiveQuantity || 0,
        );
        const totalReceiveAmount = _.sumBy(
          inventories,
          (o) => o.receiveAmount || 0,
        );
        const totalIssueQuantity = _.sumBy(
          inventories,
          (o) => o.issueQuantity || 0,
        );
        const totalIssueAmount = _.sumBy(
          inventories,
          (o) => o.issueAmount || 0,
        );

        this.initInventory.receiptId = "";
        this.initInventory.purchaseId = "";
        this.initInventory.comment = "Đầu kỳ";

        this.initInventory.balanceQuantity =
          this.product.balanceQuantity -
          (totalReceiveQuantity - totalIssueQuantity);

        this.initInventory.balanceAmount =
          this.initInventory.balanceQuantity > 0
            ? this.product.balanceAmount -
              (totalReceiveAmount - totalIssueAmount)
            : 0;
      }

      this.balanceQuantity += this.initInventory.balanceQuantity;
      this.balanceAmount += this.initInventory.balanceAmount;

      this.inventories = [this.initInventory, ...this.inventories];
    }

    _.forEach(inventories, (item) => {
      let prod = item;

      prod.receiveQuantity = item.receiveQuantity
        ? parseFloat(item.receiveQuantity.toString())
        : 0;
      this.receiveQuantity += prod.receiveQuantity;
      prod.receiveAmount = item.receiveAmount
        ? Math.round(Number(item.receiveAmount))
        : 0;
      this.receiveAmount += prod.receiveAmount;

      prod.issueQuantity = item.issueQuantity
        ? parseFloat(item.issueQuantity.toString())
        : 0;
      this.issueQuantity += prod.issueQuantity;
      prod.issueAmount = item.issueAmount
        ? Math.round(Number(item.issueAmount))
        : 0;
      this.issueAmount += prod.issueAmount;

      this.balanceQuantity =
        this.balanceQuantity + prod.receiveQuantity - prod.issueQuantity;
      prod.balanceQuantity = this.balanceQuantity;

      const rounded =
        this.balanceAmount + prod.receiveAmount - prod.issueAmount;

      this.balanceAmount = this.balanceQuantity > 0 ? rounded : 0;
      prod.balanceAmount = this.balanceAmount;

      this.inventories.push(prod);
    });
  }

  //Create
  receiveInventory(): void {
    this.dialogService
      .open(DialogProductInventoryComponent, {
        context: {
          shopId: this.shopId,
          product: this.product,
          isReceive: true,
          isEdit: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: ProductInventory) => {
        if (value) {
          console.log(
            "DialogProductInventoryComponent/receiveInventory:",
            value,
          );
          this.product = this.productService.getProductDbIndexById(
            this.product.id,
          );
          this.product.hadChange = true;
          this.inventories.push(value);
          this.calculateInventory(this.inventories);
        }
      });
  }

  issueInventory(): void {
    this.dialogService
      .open(DialogProductInventoryComponent, {
        context: {
          shopId: this.shopId,
          product: this.product,
          isReceive: false,
          isEdit: false,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: ProductInventory) => {
        if (value) {
          console.log("DialogProductInventoryComponent/issueInventory:", value);

          this.product = this.productService.getProductDbIndexById(
            this.product.id,
          );
          console.log(
            "🚀 ~ DialogProductInventoriesComponent ~ issueInventory ~ this.product after:",
            this.product,
          );

          this.product.hadChange = true;
          this.inventories.push(value);
          this.calculateInventory(this.inventories);
        }
      });
  }

  //Update
  onEdit(item: ProductInventory): void {
    let itemEditing = _.clone(item);

    this.dialogService
      .open(DialogProductInventoryComponent, {
        context: {
          shopId: this.shopId,
          product: this.product,
          isReceive: true,
          isEdit: true,
          prodInventory: itemEditing,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: ProductInventory) => {
        if (value) {
          item.issueDate = value.issueDate;
          item.comment = value.comment;
          item.receivePrice = value.receivePrice;
          item.receiveQuantity = value.receiveQuantity;
          item.receiveAmount = value.receiveAmount;
          item.issuePrice = value.issuePrice;
          item.issueQuantity = value.issueQuantity;
          item.issueAmount = value.issueAmount;

          this.product = this.productService.getProductDbIndexById(
            this.product.id,
          );
          this.product.hadChange = true;

          this.calculateInventory(this.inventories);
        }
      });
  }

  //Delete
  remove(item: ProductInventory) {
    let msg = "Bạn có chắc xóa";
    if (item.isReceive) {
      msg += ` nhập kho ${item.receiveQuantity}?`;
    } else {
      msg += ` xuất kho ${item.issueQuantity}?`;
    }

    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: msg,
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.inventoryService
            .delete(this.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;

              if (item.isReceive) {
                this.product.receiveQuantity -= item.receiveQuantity;
                this.product.receiveAmount -= item.receiveAmount;
                this.product.balanceQuantity -= item.receiveQuantity;
              } else {
                this.product.issueQuantity -= item.issueQuantity;
                this.product.issueAmount -= item.issueAmount;
                this.product.balanceQuantity += item.issueQuantity;
              }

              const numb =
                this.product.receiveQuantity != 0
                  ? (this.product.receiveAmount /
                      this.product.receiveQuantity) *
                    this.product.balanceQuantity
                  : 0;
              const rounded = Math.round(numb);
              const balanceAmount =
                this.product.balanceQuantity > 0 ? rounded : 0;
              this.product.balanceAmount = balanceAmount;

              this.product.hadChange = true;
              this.productService.updateIndexedDb(this.product);

              _.remove(this.inventories, (o) => o.id === item.id);
              this.calculateInventory(this.inventories);
            })
            .catch((err) => {
              console.log(
                "🚀 ~ DialogProductInventoriesComponent ~ remove ~ err:",
                err,
              );
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  openDetail(item: ProductInventory): void {
    if (item.receiptId && item.receiptId !== "") {
      this.dialogService.open(DialogViewReceiptComponent, {
        context: {
          shopId: this.shopId,
          receiptId: item.receiptId,
        },
        closeOnBackdropClick: false,
      });
    } else if (item.purchaseId && item.purchaseId !== "") {
      this.dialogService.open(DialogViewPurchaseComponent, {
        context: {
          shopId: this.shopId,
          purchaseId: item.purchaseId,
        },
        closeOnBackdropClick: false,
      });
    }
  }

  //api functions
  private calculateProductStats(isInit?: boolean) {
    this.loading = true;

    const d = new Date(this.product.updatedOn);
    const monthKey =
      isInit || !this.product.isArchived
        ? "initial"
        : `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;

    console.log("🚀 ~ calculateProductStats ~ monthKey:", monthKey);

    this.productService
      .calculateProductStats(
        this.shopId,
        monthKey, //initial for reset data product stats
        this.product.id,
        this.product.code || this.product.barcode,
        this.product.title,
        this.product.unitName,
      )
      .subscribe(
        (data) => {
          console.log("🚀 ~ calculateProductStats ~ data:", data);

          this.product.isArchived = true;
          this.product.hadChange = true;
          this.product.isSynced = true;

          this.product.receiveQuantity = data.receiveQuantity;
          this.product.receiveAmount = Math.round(Number(data.receiveAmount));
          this.product.issueQuantity = data.issueQuantity;
          this.product.issueAmount = Math.round(Number(data.issueAmount));
          this.product.balanceQuantity = data.balanceQuantity;
          this.product.balanceAmount = Math.round(Number(data.balanceAmount));

          this.productService.updateIndexedDb(this.product);

          this.loading = false;
          this.submitted = false;

          this.getProductInventoriesByIssueDate();
        },
        (err) => {
          console.log("🚀 ~ calculateProductStats ~ err:", err);
          this.loading = false;
          this.submitted = false;
        },
      );
  }

  archiveData() {
    this.dialogService
      .open(DialogProductInventoriesArchiveComponent, {
        context: {
          shopId: this.shopService.shop.shopIdArchived,
          uid: this.uid,
          productId: this.product.archivedId ? this.product.archivedId : "",
          productCurrent: this.product,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value: Product) => {
        console.log(
          "🚀 ~ DialogProductInventoriesComponent ~ archiveData ~ value:",
          value,
        );
        if (value) {
          this.calculateProductStats(true);
        }
      });
  }
}
